import React from "react";
import { Card, CardBody, Badge } from "reactstrap";
import "./CabCard.css";

const CabCard = ({ cab, onBookNow }) => {
  const { name, type, photo, seats, bags, ac, pricePerKm, basePrice, description, features, rating, reviews } = cab;

  return (
    <div className="cab__card">
      <Card>
        <div className="cab__img">
          <img src={photo} alt={name} />
          <Badge className="cab__type__badge">{type}</Badge>
        </div>

        <CardBody>
          <div className="cab__card__top">
            <h5 className="cab__name">{name}</h5>
            <span className="cab__rating">
              <i className="ri-star-fill"></i> {rating}
              <span className="cab__reviews">({reviews})</span>
            </span>
          </div>

          <p className="cab__description">{description}</p>

          <div className="cab__features">
            <div className="cab__feature">
              <i className="ri-user-line"></i>
              <span>{seats} Seats</span>
            </div>
            <div className="cab__feature">
              <i className="ri-luggage-cart-line"></i>
              <span>{bags} Bags</span>
            </div>
            {ac && (
              <div className="cab__feature">
                <i className="ri-snowy-line"></i>
                <span>AC</span>
              </div>
            )}
          </div>

          <div className="cab__amenities">
            {features.slice(0, 4).map((feature, index) => (
              <Badge key={index} className="cab__amenity__badge">
                {feature}
              </Badge>
            ))}
            {features.length > 4 && (
              <Badge className="cab__amenity__badge cab__amenity__more">
                +{features.length - 4} more
              </Badge>
            )}
          </div>

          <div className="cab__card__bottom">
            <div className="cab__pricing">
              <div className="cab__base__price">
                <span className="price__label">Base Fare</span>
                <span className="price__value">₹{basePrice}</span>
              </div>
              <div className="cab__per__km">
                <span className="price__label">Per KM</span>
                <span className="price__value">₹{pricePerKm}</span>
              </div>
            </div>

            <button className="cab__book__btn" onClick={() => onBookNow(cab)}>
              <i className="ri-car-line"></i> Book Now
            </button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default CabCard;
